module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('h3', {
    staticStyle: {
      "margin-top": "3em!important",
      "margin-bottom": "2em!important"
    },
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/text/05_toc#ch2"
    }
  }, [_c('em', [_vm._v("The Masterclass")])]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("B")]), _vm._v("efore making a start on the model it is, of course, absolutely necessary to have a set of plans to work from. In my previous book I worked from a set of Admiralty draughts and demonstrated a method of drawing up rigging plans from these. With many eighteenth- and nineteenth-century ships this will be the only course open to you. However, many of the more famous ships will now have commercially available plans produced for them, though, it must be said, of varying quality and reliability. Fortunately for us there is an excellent set of plans available for "), _c('em', [_vm._v("Neufchatel")]), _vm._v(", giving lines, hull profile and deck plan, hull details and fittings and sail and rigging plans. Full details for obtaining them can be found in the Bibliography at the end of the book.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("I chose to use jellutong for the hull. There are other timbers that would serve as well, but I have got used to using this; it is very stable, close grained and carves cleanly and easily.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq1.jpg"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("The Hull")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig1"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("After first sawing and then planing the blocks of jellutong to the correct plan and profile the hull was carved and then sanded to shape. All the templates were cut from copies of the lines plans mounted with double-sided tape on 10 thou plastic card. This stage in the work can be clearly seen in this first photograph.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig2"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("Because of the complex curves of the bow the forward section of the bulwarks was carved integral with the hull. This was then hollowed out with gouges and chisels. The bulwarks were finally finished with various grinders in the Minicraft tool and the deck levelled and camber introduced with a small plane, a chisel and, finally, a sandpaper block.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Gauging the exact height of the deck at the side was facilitated by drilling through from the outside at the level of the deck and flooding a little dilute water colour paint into the holes. As soon as these started to show during the carving process it was obvious that the correct level had been reached. The blue stain can be seen clearly in the photograph. Note also the ‘well’ cut below the forward companionway. The sides of these wells should be lined with black paper and the bottoms with a piece of spare decking. Also at this time, holes were drilled for the masts in the decks and holes drilled in the base of the hulls for the threaded rods to be used for mounting the models.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig3"
    }
  }, [_vm._v("3.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("This photograph shows the forward end of the rebate for the bulwark, which was left over-thick for the time being to allow the rebate to continue up the side, so making it much easier to line up the plywood strips accurately when fitting them to the hull.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig4"
    }
  }, [_vm._v("4.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Before fitting the bulwarks the decks had to be prepared. Sufficient decking material for both vessels was made up in the following way. First, some holly shavings were glued to some good-quality paper. When this was dry the paper side was treated with a coat of Seccotine and the shaving side with a good coat of clear shellac. Now the individual planks were cut from the mounted shaving and were laid up on some thin card. The glue used was Seccotine with the addition of a little raw umber watercolour to suggest the caulking. Paper templates were then prepared (one can be seen on the upper hull), these being used to mark out the decks. The rectangle in the centre of the template is there to allow the midship station line to be seen, this can then be used as a reference point for the mast holes and openings for the companionways. When the decks were cut to size they were glued in place with Evo-Stik contact adhesive.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig5"
    }
  }, [_vm._v("5.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The decks are in place and some simple ply jigs have been fitted to the deck with a few spots of superglue. The glue is only applied along the centreline, where any marks that it may leave will be covered by one of the deck fittings.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig6.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig6"
    }
  }, [_vm._v("6.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The ply bulwarks were glued in place, working from fore to aft, making sure that they lined up with the angle of the jigs. When the glue has set the jigs can be carefully broken free.")])])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig7.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig7"
    }
  }, [_vm._v("7.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The join between the ply and jellutong bulwarks then had to be reinforced as this is an obvious weak spot. The cutter in the chuck of the drill was used to cut grooves spanning the join, and small strips of ply were then inserted into the slots. These were then flooded with a very thin superglue, bonding and strengthening the whole structure. The forward section of bulwarks was then finally thinned, using burrs and sandpaper blocks, so removing the rebate originally used to locate the ply bulwark. This was now marked out for height and position of gun ports etc. and carefully trimmed to size. The ports were then opened up, but left slightly small at this stage.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig8.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig8"
    }
  }, [_vm._v("8.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The stern was next cut from the ply, glued in place and then given the same joint-stengthening treatment as the forward end of the bulwarks.")])])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig9.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig9"
    }
  }, [_vm._v("9.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("As well as the gun ports, the oar ports needed to be opened up. They were first of all drilled and then squared using this little file held in a pin vice.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig10.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig10"
    }
  }, [_vm._v("10.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The next job I tackled was the fitting of the waterway. On the ship it would have been fitted against the frames and would have butted against the edges of the deck and bulwark planking. On the model I fitted the lowest bulwark plank first and then added a small triangular plank to simulate the visible section of the waterway; there is visually no difference. I manufactured the strips of triangular material in the following way. The edge of a strip of veneer was planed to a 45-degree angle…")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig11.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig11"
    }
  }, [_vm._v("11.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("… before trimming it off on the Preac saw.")])])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig12.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig12"
    }
  }, [_vm._v("12.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("This photograph shows the lowest plank, or spirketting, that reaches the base of the gun ports, and the ‘false’ waterway.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig13.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig13"
    }
  }, [_vm._v("13.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("A tracing of the stem was made from the plans and used with some carbon paper to transfer the outline to some correctly thicknessed boxwood. Then a slot was cut in the stems with a razor saw. This was then further opened up with various diamond burrs and the stems glued in place. The keel was glued directly to the hull before dowelling along its length. The final dowel has yet to be broken off.")])])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Planking the Hull")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig14.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig14"
    }
  }, [_vm._v("14.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("A start was then made on the hull planking. The top strake was cut from some pre-painted and mounted shaving. The next three strakes (two shown here) were cut from unmounted and prepainted wood shaving as these were noticeably thinner. After fitting the two planks shown they were trimmed around the gun ports and pierced by way of the oar ports. The screwed rod in the base of this model is clearly visible here. It will be used to mount the model on a temporary work base and finally to secure it in the carved sea.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig15.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig15"
    }
  }, [_vm._v("15.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The third yellow ochre plank in place along with the thickstuff above the wales and the wales themselves.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig16.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig16"
    }
  }, [_vm._v("16.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The remainder of the hull was then planked. As the hull was to be copper plated there was no need to be too pernickety about the run of the planking below the waterline. I have seen it advocated that the hull planking need only extend to just below the waterline and then be faired into the timber hull. This seems to be a rather unsatisfactory solution, particularly if the true lines of the hull are to be preserved.")])])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("The Stern")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig17.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig17"
    }
  }, [_vm._v("17.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The sternposts were then fitted. If you look carefully you will note that this has not been done strictly according to full-size practice, as the keel does not run the full length of the ship but ends forward of sternpost, but this will be invisible and of no consequence once the hull has been coppered. The counter has been planked and the rail beneath the stern ports glued in place. On the full-hull model in the foreground I have started fitting the framing around the counter. The section on the quarters was made from strips of holly, but that beneath was built up from lengths of copper wire. This is an easy way of dealing with the complex curves involved. After gluing the wire in place the area between was filled with Roket Powder. This useful filler comes in the form of a free-flowing powder, in appearance rather like very fine sugar, and is specifically for use with superglue. I find it works best with the thinner grades of superglue. The granules are sprinkled in the area to be filled and then flooded with superglue. On large areas I use it directly from the bottle, but for something like the present application I prefer to use my usual tool: a piece of wire in a pin vice. The advantage of this type of filler is not only its strength but the instant results. Once set it can be filed or sanded to an extremely fine finish.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig18.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig18"
    }
  }, [_vm._v("18.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The counter timbers have been filled, sanded and painted. As can be seen, using the wire has given a clean flowing curve around the stern. The rudder is only temporarily in place and is held with a wire pin fitted in line with the lower hinge.")])])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Coppering the Bottom")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig19.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig19"
    }
  }, [_vm._v("19.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("With the exterior planking finished, a start can be made on the coppering. The first job is to mark in the waterline, or more accurately draw a line 1/32in above the waterline. To do this the hull needs to be set up at the correct angle. I have placed strips of timber of the requisite thickness beneath the bulwarks fore-and-aft and am here marking in the waterline using a hard pencil. Before I came across this useful little tool I simply fixed the pencil on top of a block of wood of the required height. Minor adjustments can be made when sharpening the lead of the pencil, which should be a sharp chisel point.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig20.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig20"
    }
  }, [_vm._v("20.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("I used some painted tissue paper for the copper plating on these two models. Having in the past experimented with various methods, including the use of fine copper shim, I have come to the conclusion that there really is, visually, very little to choose between them. This photograph shows a sheet of prepared tissue, taped to a cutting board and being cut into strips 5/64in wide, the depth of each sheet of copper.")])])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig21.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig21"
    }
  }, [_vm._v("21.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The steel ruler in the foreground has been fixed to the cutting board, parallel to the cuts, using double-sided tape. Now more cuts are made at right angles to the original ones at ¼in intervals, using the transparent set square that can just be seen beneath the knife. This process is a little trickier than it might seem, as, after the first cut has been made, the strips of tissue are only anchored at one end, so care is needed not to misalign them either when moving the set square or making the cuts. I found that a strip of masking tape applied to the underside of the square helped to keep the tissue in place while making the cuts.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig22.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig22"
    }
  }, [_vm._v("22.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The bench set out all ready for the coppering to begin. All that is needed is a sharp knife, a finely pointed pair of tweezers, dividers, sable brush, and some Seccotine.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig23.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig23"
    }
  }, [_vm._v("23.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The first strake of plates have been laid and trimmed with a sharp knife, the waste being gently soaked off. The second band has just been started.")])])])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig24.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig24"
    }
  }, [_vm._v("24.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("As each strake of plating extends fore and aft it will, as can be seen here, curve upwards and cross the waterline. Before starting the next one it should be carefully trimmed. Nepean Longridge in "), _c('em', [_vm._v("The Anatomy of Nelsons Ships")]), _vm._v(" recommends that the waterline be raised slightly at bow and stern to avoid the optical illusion of it appearing to sag at either end, and I have done that here.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig25.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig25"
    }
  }, [_vm._v("25.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Six strakes have been laid working downwards from the waterline and one strake has been laid alongside the keel. The remaining five strakes have been started and now it is just a matter of working steadily fore and aft.")])])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig26.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig26"
    }
  }, [_vm._v("26.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Three complete strakes are laid working upwards from the keel. These have been completed on the starboard side. From now on it will be necessary to trim some of the plates as certain strakes gradually diminish and disappear. At the stern there are also a number of stealers required")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig27.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig27"
    }
  }, [_vm._v("27.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The fore end of the hull with the plating completed. The keel has been drilled in line with the holes already drilled for the threaded stainless steel rods, and these have been fitted. The side of the keel has been plated and I am now in the process of working my way up the stem.")])])])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig28.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig28"
    }
  }, [_vm._v("28.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Keel, stem and sternpost have been coppered; plates are also laid along the underside of the keel, along the edges of the stem- and sternposts and up the trailing edge of the rudder. The hinges have also been fitted.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig29.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig29"
    }
  }, [_vm._v("29.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("These were made from the same copper-painted tissue as the plates. A thin strip was cut and the rivets simulated by pressing into the back of the strip with a sharpened needle in a pin vice.")])])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Detailing and Planking the Bulwarks")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig30.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig30"
    }
  }, [_vm._v("30.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The next job that can be done is to cut an opening for the bowsprit. I first drilled a small hole and then opened it up to the correct diameter with this diamond burr.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig31.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig31"
    }
  }, [_vm._v("31.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Now to complete the internal planking of the bulwarks. The first plank above the spirketting has been glued in place and I am trimming any unwanted areas by way of the gun and oar ports. The scalpel blade being used has been sharpened to a needlepoint to enable me to trim the latter neatly. I find I am always reshaping and sharpening many of the tools I use. It is a good habit to get into because it is just not possible to have tools and blades that are just perfect for every sort of specialist work. A good sharpening system helps immeasurably. I have recently invested in a powered tool sharpening system that has both a water-cooled grind wheel and a leather surfaced polishing wheel. It puts a razorsharp edge on all the cutting tools I use.")])])])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig32.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig32"
    }
  }, [_vm._v("32.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("After working my way up the bulwarks, trimming as I went, I moved on to the stern, which can be seen here planked but still with some trimming and neatening required.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq2.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Working Bases for the Hulls")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig33.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig33"
    }
  }, [_vm._v("33.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("These are the two working bases I have made up for the models. The one at the back needs no description but the other, for the full-hull model, needs a little explanation. Any jig for supporting a model during construction needs to keep the model firmly and accurately in an upright position and do so without damaging the hull. Once the basic three-sided jig was assembled, holes were drilled in the base to accept the threaded rods, and two little blocks of jellutong were roughly carved to fit the contours of the hull. The inner surfaces of these blocks were then liberally coated with some model filler and a couple of strips of felt laid over them; these were further covered with some thin polythene, in case any of the filler bled through. With the hull in place, upright on the jig, the blocks were gently pressed in from either side, checking repeatedly that the model remained upright. As an aid to this I placed a 6in ruler across the bulwarks amidships and checked the height either side at the edge of the jig. When I was satisfied that all was as it should be, a few spots of superglue were applied along the edge of the jellutong supports to fix them in place. When the filler had set the model was lifted free and the polythene discarded. The little model could now be removed and replaced in its cradle whenever required without risk of damage to the delicate copper plating.")])])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig34.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig34"
    }
  }, [_vm._v("34.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("With all the planking and copper plating completed, it was time for a clean-up. All the ports, both gun and oar, are given a final trim and file, checking each gun port for both height and width with a little plastic card jig. Then the whole model was given several wipe-overs with a damp cloth. For obvious reasons this needs to be sensitively done with immediate ‘dry-offs’ between ‘washes’. This will remove all traces of Seccotine from the planking and copper plating. At this stage any of the paintwork that needs it is given a touch-up using several coats of very dilute paint so as not to obscure the delineation of the planking. Careful painting is also required around the various ports. When thoroughly dry the copper plating was given a coat of medium-oak-stained varnish to mellow and enrich the copper effect; this was followed by an overall coat of slightly diluted satin matt polyurethane varnish for protection. Later I decided to weather the copper a little with some dilute washes of Windsor and Newton’s cobalt green oil colour.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig35.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig35"
    }
  }, [_vm._v("35.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("I frequently recall the modeller Harold Underhill’s enthusiasm for plank-on-frame construction. He maintained that once you had a keel, stem and sternpost assembly you had a model of sorts, and I do agree that it is satisfying to see a model ship grow in this way. With solid hull models such as these we do not have that satisfaction, but there are compensations. There are certain stages in the building process when transformations take place, and I always feel that this is one of them. Instead of seeing ship-shaped blocks of wood and ply, two miniature hulls begin to take on the character and graceful lines of the "), _c('em', [_vm._v("Neufchatel")]), _vm._v(".")])])])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("The Main Rail, Channels and Pin Rail")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig36.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig36"
    }
  }, [_vm._v("36.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("I decided to make the rail from boxwood, so thicknessed a plank in my Preac thicknesser, a most useful recent acquisition. Before owning it I would have used a sheet of suitable veneer. Here the outer edge of the rail is being marked on the underside of the timber.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig37.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig37"
    }
  }, [_vm._v("37.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Once marked, the outside of the rails were cut and carefully sanded to the line; then the width of the rails was marked in with this tool. It is simplicity itself. Two scraps of wood are held in a small clamp. One of them has a rounded end and the other a small hole drilled in it, in which a short section of 0.3mm clutch pencil lead has been glued. Then the rail is carefully cut from the sheet, leaving a little to spare.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig38.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig38"
    }
  }, [_vm._v("38.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The inside edge can then be finished with a disc sander along the side of the ship and with the drum sander, in the background (in perfect focus, unlike the rest of the picture; I am still adapting to digital technology) around the bow section.")])])])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig39.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig39"
    }
  }, [_vm._v("39.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The rails are finished, but before fitting them there is one more job to be done; fitting the channels, such as they are, and the pin rails. This proved to be a very simple procedure on this vessel as they are both situated at the same level and fit immediately beneath the rail. This photo shows a groove being cut to accept the piece of boxwood that will form both channel and rail. Note the well-honed and sharpened blade.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig40.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig40"
    }
  }, [_vm._v("40.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The strip of boxwood cut roughly to size and glued in place. Once this had been done for all the channels on both models the rails were fitted. I used superglue for this and worked my way gradually from bow to stern, applying the glue little by little using a piece of fine wire in a pin vice as applicator.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig41.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig41"
    }
  }, [_vm._v("41.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The rail glued in place. Both channel and pin rail have been trimmed and sanded to their finished dimensions, and the pin rail has been marked out in pencil ready for drilling for the belaying pins.")])])])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("The Bow and Figurehead")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig42.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig42"
    }
  }, [_vm._v("42.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Now to move on to the head. Not a major or difficult job on a little ship like this.")]), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The first details to be fitted are the upper and lower cheeks. These were trimmed from a sheet of card and glued in place with superglue. I started this process at the point where the hull planking meets the stem. The exact position was ascertained by measuring down from the rail, and then little by little I worked fore and aft, checking angle and curve, applying the glue, as usual, with a thin wire.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig43.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig43"
    }
  }, [_vm._v("43.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_c('em', [_vm._v("Neufchatel")]), _vm._v(", according to Howard Chapelle, was fitted with a coronal figurehead. But as this was indistinguishable on the original plans I have resorted to my own interpretation. I built the crown from a circlet of paper with two rings of fine wire around the outside, top and bottom. This was then filled with some modelling putty to form the velvet lining before forming the rest of the crown from more paper strips. A tiny glass bead was added to the top and a little wire shield fitted beneath it. This was then filled with a little of the putty. As you can see from the photograph it is barely 1/16in across")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig44.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig44"
    }
  }, [_vm._v("44.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The head rails and timbers, like the cheeks, were cut from card. I used quite a soft absorbent card for these, and then, when they were completed, treated them liberally with thin superglue. This creates a very strong structure that can easily be filed and sanded to a smooth finish. Artist’s gesso was used to develop the figurehead further and to add a little decorative scroll beneath it. This was applied with the tip of a 0000 sable brush and built up in several layers.")])])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig45.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig45"
    }
  }, [_vm._v("45.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Strips of yellow painted tissue were next cut and applied to the rails, cheeks and head timbers. A boxwood hawse timber was shaped and fitted just above the upper cheek and the hawsehole carefully drilled through the hull so as to emerge on the inside of the bulwarks just above the waterway. Just below the upper cheek a slot has been filed ready to accept the gammoning to the bowsprit.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq3.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Deck Fittings")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig46.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig46"
    }
  }, [_vm._v("46.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Now to move on to the deck fittings. I am making a start with the companionways. "), _c('em', [_vm._v("Neufchatel")]), _vm._v(" has one forward and another incorporated in the half deckhouse aft. At this stage they are simple shell constructions formed from home-produced three-ply of yellow cedar shavings.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig47.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig47"
    }
  }, [_vm._v("47.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("To ensure a tight fit with the deck the heavier moulding that runs round the base of the deckhouse is being glued in place "), _c('em', [_vm._v("in situ")]), _vm._v(". It is here being held firmly against both deck and deckhouse with a pair of tweezers while the glue sets. The end of the moulding on the far side can just be seen. Both will be trimmed flush with the house before fitting those at the ends. The end timbers will need to be slightly curved to accommodate the camber of the deck.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig48.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig48"
    }
  }, [_vm._v("48.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The companionway forward is treated in a similar fashion, only this time, instead of sitting directly on the deck, it fits inside the opening cut to receive it.")])])])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig49.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig49"
    }
  }, [_vm._v("49.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("While fitting the remainder of the framing it is most helpful if some means of holding these tiny fittings can be fabricated so as to allow freedom for both hands to do the work. These little clamps have many such uses, though much can be accomplished with clothes pegs, elastic bands and a little ingenuity.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq4.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig50.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig50"
    }
  }, [_vm._v("50.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The panelling on the sides of the deckhouse is fitted and the positions of the skylights and companionways have been marked in and are being opened up.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig51.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig51"
    }
  }, [_vm._v("51.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The sides and ends of the skylight have been built up and the skylight glazed with clear plastic. In the foreground the two forward companionways are almost ready for their tops and doors.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig52.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig52"
    }
  }, [_vm._v("52.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The sliding tops to the companionways have been fitted, along with the framing to the skylight. All this work was carried out using boxwood.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig53.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig53"
    }
  }, [_vm._v("53.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The bitts are fairly straightforward to construct, as should be clearly seen in this photograph. Note the dowels carved as part of the uprights; these locate directly into the holes drilled in the deck. Again all this work was carried out using boxwood.")])])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig54.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig54"
    }
  }, [_vm._v("54.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The "), _c('em', [_vm._v("Neufchatel")]), _vm._v(" was fitted with small winches mounted on the fore and main bitts. Here one of the wooden drums is being turned using a scrap of sandpaper.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig55.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig55"
    }
  }, [_vm._v("55.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("After each one is finished it is parted off with a sharp knife blade.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq5.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig56.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig56"
    }
  }, [_vm._v("56.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The finished drums mounted on their wire spindles. The handles would have been removable, so only the one pair has handles made from the wire, as I do not at this stage intend showing the other three in use.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq6.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig57.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig57"
    }
  }, [_vm._v("57.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Three of the completed and stained bitts with the winches glued in place. The metal plates that support the winches were made from strips of black paper.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq7.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig58.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig58"
    }
  }, [_vm._v("58.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("Only two small gratings are required for each ship, one for the scuttle right aft and one over the galley stove. I used some left-over grating material from a previous model. This was originally constructed in exactly the same way as shown in "), _c('em', [_vm._v("Modelling Sailing Men-of-War")]), _vm._v(", in which I gave detailed pictorial coverage, but I will explain here the method used in brief. The Preac saw was used to prepare the gratings and for 1/192 scale I used a 12 thou saw blade. A sheet of thin boxwood about 2in square was partially run across the saw table and then secured in this position with double-sided tape. This forms a new top to the table that fits snugly against either side of the nearest end of the blade. It is now possible to cut very narrow strips of timber to a fine tolerance and excellent finish. A guide made from 12 thou square boxwood is next glued to the new boxwood table parallel to the saw blade and exactly 12 thou away from it. The saw was then set to a depth of 12 thou and a sheet of boxwood about 2in by 5in and 1/32in thick was run across the saw with the shortest end against the guide, so cutting a groove in the underside 12 thou from the end of the timber. The next cut was made by running the wood again across the saw but this time with the first groove running snugly over the guide. This process is repeated, cutting successive grooves 12 thou apart along the length of the timber. The saw blade is now raised and 12 thou strips cut lengthways from the grooved stock. These will form the cross-members of the gratings. With the saw still set to cut 12 thou strips some boxwood is run down into 12 by 12 thou square lengths.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Now the grating is made up by fixing the notched lengths of wood to a board with narrow strips of double-sided tape, notches uppermost. They are attached to the tape at the ends only, and laid out parallel to one another. At either end short spacers of the 12 thou square timber are fitted tightly between them. Now lengths of the square stock are glued at right angles to these in the grooves. First, every tenth notch is treated in this way, fitting temporary spacers alongside them. When the glue is dry these spacers can be removed and the remaining lengths of timber glued in place.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The photograph shows the gratings cut to size and being fitted with their coamings. All the constituent parts are glued down to the paper backing, each being trimmed accurately to size before the next is fitted.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig59.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig59"
    }
  }, [_vm._v("59.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("A similar technique was used for the hatches, but these were covered with boards, not gratings. I made these up the same depth as the coamings, as can be clearly seen in this photograph.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig60.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig60"
    }
  }, [_vm._v("60.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("When building small-scale models one of the eternal challenges is how to avoid damaging delicate or vulnerable details already completed. The catheads for "), _c('em', [_vm._v("Neufchatel")]), _vm._v(" are an example. On the vessel herself they would have been fashioned from carefully selected compass timber with the grain following the bend. To cut them from sheet timber would have made them very vulnerable to accidental breakage, so I glued together two sheets of 1mm modelmakers’ ply and made mine from that.")])])])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig61.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig61"
    }
  }, [_vm._v("61.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Holes were drilled either end of the sheaves, a slot fashioned and the space between the holes rounded off using this home-made drill to suggest the sheaves.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig62.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig62"
    }
  }, [_vm._v("62.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The catheads ready for a final sand before painting; note that they have been fitted with cleats for the anchor ring stoppers. In the foreground are the various timber heads that will be fitted to the rails")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq8.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig63.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig63"
    }
  }, [_vm._v("63.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("A fair number of cleats are going to be needed; the larger ones were made from a strip of boxwood by the method shown here. They were then mounted on wire pins for inserting into drilled holes in the bulwarks.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig64.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig64"
    }
  }, [_vm._v("64.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("For the smaller cleats I used some brass etched ones that I had made up some years ago. Before I had made these I used to make these little fittings from copper wire either by bending the wire around the circumference of the cleat with the two ends forming the pin for fitting in the bulwark, or by soldering together a small T of copper wire and then filing it to shape.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq9.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq10.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig65.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig65"
    }
  }, [_vm._v("65.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("For the two models at least four hundred ringbolts will be required. Some of these are for the gun carnages, some for the bulwarks and others for the deck. I have found no short cut for producing these, so they have to be made up individually. I do this initially by winding a loop around a drill shank, as shown here, then cutting away the surplus wire with a sharp knife, and finally straightening the shank with tweezers.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig66.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig66"
    }
  }, [_vm._v("66.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Yet another repetitive job is the production of all the coils of rope required, some of which will be for the decks and others for the pin rails. Some wire is first wound round a drill shank of suitable diameter. Then several coils are cut from the resultant winding and flattened with a steel rule for use on the deck, or shaped over a pin driven into the edge of a block of wood ready for fitting to a belaying pin.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig67.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig67"
    }
  }, [_vm._v("67.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("The ringbolts have been mounted in strips of plasticine pressed on to battens of wood, and the rope coils also mounted on battens but by means of narrow bands of double-sided tape. Each coil should only be attached to the tape at its very edge, otherwise they will prove extremely difficult to remove without damaging them.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("I now airbrush all these little fittings. It is easily the quickest and most efficient method of painting them. The only other viable alternative is to paint the rigging wire before winding the coils. I would advise against trying to brush-paint coils of rope after they have been made, as the paint will fill between the individual rope strands and spoil the whole effect.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Guns, Anchors and Port Lids")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig68.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig68"
    }
  }, [_vm._v("68.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("This photograph shows a length of boxwood dowel, used for making the gun barrels, in the chuck of the lathe, with the remainder of the previous barrel turned still in evidence. The card jig determines the length of the barrel plus about ⅛in. The taper is already set and the barrel is turned in one slow cut. If the barrels are always set to this exact length they will all be turned to the same size and taper.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig69.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig69"
    }
  }, [_vm._v("69.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The turned barrel is cleaned up with some fine sandpaper, and then a second card jig is used to determine the length of the barrel. It has been marked in and will now be parted off using a fine razor saw.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq11.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig70.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig70"
    }
  }, [_vm._v("70.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The barrels are then drilled at either end with the home-ground drill and then the muzzle opened up with a small twist drill. The lengths of wire that are glued in the far end of the barrels will form a useful handle for the time being but will eventually be cut down to form the basis for the cascabel, built up finally with a little glue. The reinforcing rings are made from copper wire wound round various-sized twist drills and are glued in place with a touch of superglue. The barrels shown here are for the carronades, and for these another hole will be drilled just forward of the middle ring and a second wire inserted at right angles to the barrel; these will eventually be used to fix the carronade in place by passing them through the carriage and locating in a pre-drilled hole in the deck. The cannon barrels will be drilled and fitted with wire trunnions and will eventually be fixed to the deck, after first gluing in place, by drilling down through the vent and inserting a wire pin at this point down into the deck.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq12.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig71.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig71"
    }
  }, [_vm._v("71.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The sides of the cannon carriages were made by the following method. A strip was cut from the end of a length of box producing a strip with the grain running across it. It was then shaped as shown in the picture by repeatedly running across the Preac saw, finally finishing off the curve underneath with a small file. Then sides can be sliced off, again on the Preac saw. Only four will be required but the strip can be put aside for future models. The sides are now mounted on the axles; these are allowed to protrude slightly either side and the trucks then glued directly to them. These can be turned from box, or at this scale punched from card. Short lengths of fine dowel or wire are used for the ends of the axles and they can either be glued directly in position or, as I prefer to do, drill a hole through the truck into the axle before fitting, so making a stronger fixing.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig72.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig72"
    }
  }, [_vm._v("72.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The basic construction for the carronade beds. When dry the ends are rounded off with a disc sander.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig73.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig73"
    }
  }, [_vm._v("73.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The carriages have been fitted to the top of the beds and here they have been turned over and are now being fitted with the trucks. These are being cut from a boxwood dowel by rolling the dowel while pressing down with the knife. This just about completes the work on the guns apart from painting and the fitting of the required ringbolts.")])])])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq13.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig74.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig74"
    }
  }, [_vm._v("74.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("I made the shanks and arms for the anchors from brass rod; these were silver soldered together and then shaped with the disc sander and small files. Anyone who has not ventured into silver soldering would be well advised to give it a try. The materials required are readily available from any good supplier of jewellery-making materials.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig75.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig75"
    }
  }, [_vm._v("75.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The palms (from paper) have been fitted and stocks of boxwood constructed. When these are glued in place it only remains to make and fit the rings, paint the anchors and stain the stocks. Several coats of wood glue can be used to build up the puddening on the anchor ring.")])])])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig76.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig76"
    }
  }, [_vm._v("76.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("I chose to make the port lids from a strip of thin boxwood. This was then grooved to delineate the planking, using the cutter shown in the picture. It was made from a strip of junior hacksaw blade; a hook is shaped at the end, the point of which is then sharpened to a V. In use it is drawn gently along the edge of a steel rule several times before gently cleaning up the groove with some fine wire wool. The individual port lids are then cut off on the Preac saw. Alternatively thin card could be used, planked as the hull, and the lids cut from the strip using a sharp knife. Incidentally, the notches on the underside of the blade are used to produce mouldings from strips of boxwood; they were cut using a fine dental diamond burr.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig77.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig77"
    }
  }, [_vm._v("77.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The lids have been painted and are here being detailed. They have been drilled for wire hinges and ringbolts, the wire hinges will not be visible on the finished model. The hinge straps were made from pre-painted paper. One of the ringbolts is being fitted; it must now have another ring formed on the underside by winding once around the drill shank before being trimmed off.")])])])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig78.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig78"
    }
  }, [_vm._v("78.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Now two small holes are drilled at an angle for the wire hinges to locate in. The port lids are vulnerable fittings and so are set on one side for the time being.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq14.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq15.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Sweeps, Boarding Pikes and Fire Buckets")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig79.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig79"
    }
  }, [_vm._v("79.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Sweeps will need to be made to be stored on deck. They were made in the following way. A piece of boxwood a little wider than the sweeps are long, and as thick as the width of the blades, is prepared. This is now run repeatedly over the saw blade either side of the wood, leaving the thickness of slightly more than the diameter of the shaft.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig80.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig80"
    }
  }, [_vm._v("80.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The sides are now sanded smooth and the finished shape of the blades formed with the disc sander. Individual sweeps can now be sliced off, the little blocks at the ends removed and then the sweep is finished by turning on the lathe, one end at a time. The blade is then finished by hand. A finished sweep can be seen in the foreground.")])])])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig81.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig81"
    }
  }, [_vm._v("81.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Boarding pikes are also easily overlooked. They were made from fine brass wire. Each was put in a pin vice and the point sharpened by rotating it against a drum sander.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig82.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig82"
    }
  }, [_vm._v("82.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Three fire buckets are required for each model. They are turned from boxwood and then hollowed with a fine diamond burr, finally being parted off very carefully with a sharp knife. The handles were fashioned from wire.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq16.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Ringbolts and Ladders")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig83.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig83"
    }
  }, [_vm._v("83.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("Another lengthy job involves fitting the ringbolts for the guns. It is very important to be careful only to drill partway through the bulwark. Some modellers drill these holes before planking the outside of the hull, which is a wonderful idea if you can remember to do it.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Another feature to note here are the cleats above and just to the right of the gun ports; these are for the lanyards for raising the port lids, and they should be fitted at this stage.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig84.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig84"
    }
  }, [_vm._v("84.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The ladder fitted for the stern companionway. It has been painted buff as a foundation for ‘wood stain’ that has yet to be applied.")])])])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Boats")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig85.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig85"
    }
  }, [_vm._v("85.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("Boats can be built at any stage of the project. First, a wooden hull is carved from some fine-grained hardwood, using, as with the ship itself, templates for plan, profile and section. This is carved ‘over deep’ and with a reasonable wedge of wood left above the sheer line. Screws are then inserted in the top of the hull to form handles.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Next, a cardboard tray is made to contain the filler used for the female mould; the inner drawer from a matchbox is ideal for many of the smaller boats. The wooden male mould is now rubbed over with candle wax, the tray filled with car body filler and the male mould pressed into it till the filler is just above the sheer line. A little gentle pressure should be kept on the tops of the screws until the filler starts to go off to make sure that the wooden hull does not tend to float upwards. When set, the hull is worked free from the filler and then sanded down all round so that when replaced in the female mould it leaves a gap of about 10–15 thou. The moulds are then ready for use.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig86.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig86"
    }
  }, [_vm._v("86.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The casting of hulls in ABS plastic sheet is really quite simple, though you may find that some practice is required, and that several castings for each hull are needed before you are satisfied with the result. In practice, a sheet of plastic is placed over the waxed mould and this is held under an electric grill until the plastic softens and sags. This is not always as simple as it sounds as the plastic sheet will initially try to roll itself into a cylinder or convolute in some other way, anything other than lie flat the way you want it to. I have taken to holding it flat with a strip of wire mesh, as shown in this picture, at least in the initial stages of softening.")])])])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig87.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig87"
    }
  }, [_vm._v("87.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("When the plastic has softened sufficiently the mould is withdrawn from under the grill and the male mould pressed firmly in place and held there for a few seconds while the plastic hardens.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig88.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig88"
    }
  }, [_vm._v("88.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("I have so far not made any mention of the largest of "), _c('em', [_vm._v("Neufchatel")]), _vm._v("’s boats. The plans show an outline on her deck for what appears to be a 28ft cutter, which would be a logical choice. I had no available mould, but had one for a slightly shorter boat so decided to make use of that. In this photograph can be seen the slightly lengthened hull and the new female mould prepared for it. Although this may seem a simpler solution to the whole process it is only usable when the subject has no concave curves.")])])])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig89.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig89"
    }
  }, [_vm._v("89.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The mould in use. The plastic has been softened and the hull former pressed into place.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig90.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig90"
    }
  }, [_vm._v("90.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The hull form seen from below before extracting the casting from the mould.")])])])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig91.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig91"
    }
  }, [_vm._v("91.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Once the required numbers of castings have been taken they can be trimmed to size and thoroughly cleaned up to remove any traces of wax. I usually use an old stiff bristled paintbrush, starting out with white spirit and finishing up with hot water and detergent.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig92.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig92"
    }
  }, [_vm._v("92.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Strips of boxwood have been cut to size for the keels and they have been glued to the hulls.")])])])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig93.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig93"
    }
  }, [_vm._v("93.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Stems have been cut and fitted and at the stern wedges of wood inserted between the hull and the keel. As can be seen they are considerably wider than the keel.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig94.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig94"
    }
  }, [_vm._v("94.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Using the burr shown in the photograph the blocks can now be shaped to blend with the curves of the hull.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq17.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig95.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig95"
    }
  }, [_vm._v("95.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Keelson and gunwale fitted and card jigs prepared, they have the position of all the thwarts marked on them. These positions are marked on either side of the boat.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig96.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig96"
    }
  }, [_vm._v("96.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Now the frames can be fitted. Here I am positioning two between each thwart. They are cut from paper and glued in place with superglue.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq18.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq19.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig97.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig97"
    }
  }, [_vm._v("97.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The outsides of the cutters have been planked with paper, a backboard added and paper boards fitted to the bottom of the boat.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig98.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig98"
    }
  }, [_vm._v("98.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("With the interiors finished they are painted with the airbrush. This gives a nice even finish and gets into all the awkward corners, under the bottom boards etc. Now thwarts are being prepared from boxwood.")])])])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig99.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig99"
    }
  }, [_vm._v("99.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Gratings and thwarts in place and crudely shaped knees fitted where required; they will now be finally shaped with a diamond burr.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig100.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig100"
    }
  }, [_vm._v("100.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("One of the finished launches. Note the finished shape of the thwart knees, the heavy breasthook and the boxwood windlass.")])])])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("The Completed Hulls")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig101.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig101"
    }
  }, [_vm._v("101.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("Now, with all the fittings made, it is time to start assembly. However, before moving inboard it is a good idea to fit the gunport lids along with their lanyards and then engineer some sort of protection for them. The two pieces of wood shown here not only serve that purpose but are also invaluable hand rests while working on the decks. I have included a rule to give some idea of scale.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The following photographs are taken in close up and should give a good idea of the models prior to making a start on the rigging. One particular point of interest and one that many of you, particularly on this side of the pond, may have noticed is the absence of either windlass or capstan. Many of the American privateer schooners of this period were not fitted with either. With their large crews they were able to manhandle the anchors using a series of double or treble purchases, two for each cable. In practice one block would be nipped to the cable forward and the other to a ringbolt aft.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig102.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig102"
    }
  }, [_vm._v("102.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The completed bow of the model with all the fittings in place including timberheads and a variety of cleats. Coils of rope have been glued to the decks where required and hanks fitted to all the pin rails.")])])])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig103.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig103"
    }
  }, [_vm._v("103.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Midships and the boats. The oars for the boats were brass etched, I had several sheets of a variety of fittings made up for me some years ago. Some have been useful but many, in my opinion, did not give as good a finish as is obtained by more traditional methods. Miniature oars, for instance, can be made from fine brass wire, the blades being beaten flat with a jeweller’s hammer. Other points of interest here are the small-arms chest just under the bow of the launch and the storage of the sweeps, spare spars and timber. These are all fixed down to the deck both with glue and either twisted tails from the lashings (the sweeps), or, in the case of the spare spars and timber, holes drilled and copper wire pins inserted between strands of the lashings. These were then teased back into position. The ropes securing the boats also feed down and are glued in holes pre-drilled in the deck.")])])])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig104.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig104"
    }
  }, [_vm._v("104.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Of interest here are the pumps and drinking water barrel. This was turned from boxwood; individual staves were scored in with a knife, it was stained and had paper hoops fitted. Note also the shot in the garlands; these were tiny painted glass beads that were very kindly given to me a little while ago. Before that I made all my shot from Milliput, a most tedious job, particularly on a large vessel.")])])])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig105.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig105"
    }
  }, [_vm._v("105.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Looking aft, giving a clearer view of the pumps and fire buckets with their rope handles. Just behind them are another pair of small-arms chests that I chose to fit. Also to be seen are the boarding pikes racked on top of the aft deckhouse.")])])])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig106.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig106"
    }
  }, [_vm._v("106.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The stern of the schooner, looking down the stern companionway, and a good view of the second cutter with its attendant tackles.")])])])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Carving a Sea")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("At this stage, while the models are relatively easy to handle without damaging them, thought has to be given to their final display. In this instance the waterline model will be set in a carved wooden sea and the full-hull model mounted on two cradles.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig107.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig107"
    }
  }, [_vm._v("107.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("A couple of years ago I managed to obtain some boards of Tupelo. This tree comes from the flood plains of the southern United States and is widely used by carvers there. It is readily available in the US but is less easy to obtain in Great Britain (See Materials and Tools, page 126). So far I have used it to carve several seas, and have rather mixed feelings about its qualities. It is quite unbelievably light, stable and tough, but will tear while being carved unless the tools are kept razor sharp. So steer clear unless you have the ability to keep tools at this pitch. But with the sharpest of tools it carves like a dream, in any direction either along or across the grain. In fact, it sometimes feels more like carving hard cheese than wood.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("This photograph shows a board, planed and thicknessed, and with a recess routed to accept the hull. This was made slightly smaller than the waterline dimensions of the model to allow for final trimming to size. This is done by repeatedly offering the hull up to the sea, marking in, and then carefully trimming the edge back little by little with either chisels and gouges, or a suitable burr in the Minicraft drill. If the ship is to be heeling to port or starboard then the recess will either have to be cut deeper on one side or, if the recess is of sufficient depth, a small batten of wood can be glued on one side of the recess. Note also the holes drilled to accept the screwed rods in the base of the hull; these also have to take into account the heel of the ship and are best drilled before cutting the recess, though as you can see if you look carefully I ended up re-drilling several times before I was happy with position and angle. There is quite a lot of trial and error in getting the ship to sit ‘just right’ in the board. It is quite important to continually try and visualise the ship with the sea carved and sails set. On the underside of the board two round recesses have been routed to allow washers and nuts to be fitted to the ends of the threaded rods fitted in the hull.")])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig108.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig108"
    }
  }, [_vm._v("108.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The actual carving is done with a ‘Flexcut’ gouge. I have been using these excellent little tools for a while now; there are a whole range of interchangeable blades and they hold a very sharp edge. They are also small and handy when working at these small scales. Before making a start mark in the wave crests, and all the time while carving, keep in mind the wind direction and the appearance of the final picture you wish to create. When satisfied with the result the sea can be lightly sanded or rubbed over with some fine wire wool.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq20.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig109.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig109"
    }
  }, [_vm._v("109.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("The final job in the shaping of the sea is to add bow wave, wake and wave crests. The model has been wrapped in very thin polythene with as close a fit around the sides as possible, with short strips of adhesive tape to hold it in place. Next I prepared some Milliput epoxy putty and rolled out some thin strips, and these were pressed firmly in place around the top of the inside of the recess for the hull. These strips were then treated to a good warm-up with a hair dryer to soften the putty and then the model was pressed firmly into the recess and the washers and nuts fitted and tightened until the model was sitting at the correct water level both fore and aft. Finally, using a modelling tool, or a sharpened strip of boxwood, trim away the putty that will have oozed up the side of the hull and shape, from some fresh putty, the bow wave and other adjacent wave crests. When dry trim back the polythene so that the model can be removed before peeling away the remains of the polythene. Sometimes models can be quite stubborn to remove, but a few gentle taps on the ends of the screwed rods usually does the trick.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The sea can now be given several coats of undercoat, I prefer something quite neutral like a mid-grey, as white can take several coats of enamel to cover completely. In between coats a gentle rub down with fine sandpaper or wire wool should be given. I paint my seas with Humbrol enamels, and spend quite a time mixing the exact colours and shades that I think I shall need. Then I just wade in, the darker shades go on first, even darker close to the hull, then before it can dry, lighter areas are blended in towards the tops of the waves, finally the crests are painted white. When dry it can be given a couple of coats of varnish. I personally do not think that it is a good idea to use gloss automatically. It works well on a glassy calm but where the wind whips across the waves and the tiny ripples produce a matting effect, then a satin finish seems appropriate.")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Making Cradles")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig110.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig110"
    }
  }, [_vm._v("110.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("Supports of some description now have to be provided for the other model, and many options are available, but I have chosen to make a pair of boxwood cradles.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The first step is to make a card jig for each of them, which is needed primarily to establish the angles of the hull at the relevant points and also the base of the cradle where it sits on the plinth.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig111.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig111"
    }
  }, [_vm._v("111.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Using the templates, the angles are marked on some timber and the rough for each of the cradles drawn freehand. A tracing of each is then taken, turned over, and the second sides transferred to the wood.")])])])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig112.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig112"
    }
  }, [_vm._v("112.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Cut to shape, but a little oversize, using the fretsaw.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig113.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig113"
    }
  }, [_vm._v("113.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("I have now set one of the cradles in a machine vice and am drilling through the centre to accommodate the threaded rod. If you are doing this job without these facilities, drill from each end with a very small drill bit, and then gradually enlarge the hole with successively larger bits.")])])])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig114.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig114"
    }
  }, [_vm._v("114.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Now each of the cradles can be threaded on its rod and offered up to the hull. The first job is the opening up of the slot for the keel; when this fits mark as shown on all sides of the cradle and then remove and trim or sand down to the lines.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig115.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig115"
    }
  }, [_vm._v("115.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("When satisfied with the fit to the hull, check that they both sit flush and level on the plinth.")])])])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig116.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig116"
    }
  }, [_vm._v("116.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Now check that the little ship is sitting upright. The dark rectangle to the right is actually the back of the handle of a little engineer’s square. It is fixed, with double-sided tape, to the back of the large set square on which is marked a green grid, supporting it, and ensuring that it is upright. In the foreground is another set square lined up with the side of the plinth. Now it is possible to stand back from the model and see if any more adjustments are required.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig117.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig117"
    }
  }, [_vm._v("117.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("When the fit is satisfactory they can be removed, and then trimmed and sanded to their final shape, ready for painting or staining.")])])])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Masts and Spars")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("I shall outline the basic techniques that I use both at this scale and at the smaller scale (1/384) to which I sometimes work. I would not, for instance, use thread at either of these smaller scales, but rather complete all the rigging with wire. For some models a masting and rigging plan needs to be prepared, but with his subject all the information can be gleaned from the extant plans.")]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "1em!important"
    }
  }, [_vm._v("The first job is to prepare some timber for the masts and spars. I used lemonwood but I think box works just as well. I ran off enough for all the masts and spars on the Preac saw, initially just as square stuff, but some was planed to octagonal section and then finished round on the lathe.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig118.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig118"
    }
  }, [_vm._v("118.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("I should explain that ‘lathe’ here is the Minicraft drill that I have semi-permanently mounted on the right-hand side of my work bench. It is handy for all sorts of small turning jobs and will cope with all these tiny masts and spars without the need to keep going next door to my Unimat lathe.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("In practice one end of the timber is placed in the chuck and the other end sanded round with the disc sander, while steadying the spar with the other hand. This can then be reversed and the other end treated similarly. Note the dust extraction nozzle on its flexible tube.")])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig119.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig119"
    }
  }, [_vm._v("119.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The lower masts can be sanded to the correct dimensions, using the disc sander, but should be finished with a sanding board made from wood or card with some fine sandpaper fixed to it with double-sided tape. A selection of these boards in different sizes and grades is invaluable for this work. The mastheads are cut square with a knife and then cleaned up with a file; they will be finished to their final dimensions later.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig120.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig120"
    }
  }, [_vm._v("120.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The spars are first planed octagonal before mounting them in the lathe and sanding to shape one end at a time with the rotary sander and boards, the central section being left octagonal.")])])])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig121.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig121"
    }
  }, [_vm._v("121.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The topmasts were made from square stuff, made over-long and turned round at the ends so they can be fitted centrally in the chuck. The centres were then shaved to an octagonal section with a sharp knife and finished round on the lathe.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig122.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig122"
    }
  }, [_vm._v("122.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The topgallant masts were turned, including their trucks, in the same manner. The diamond burr in the foreground is very useful for cutting the underside of the trucks.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq21.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig123.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig123"
    }
  }, [_vm._v("123.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("A shoulder has been cut to accept the cheeks, which are shown here at different stages of completion. To the back they are cut roughly to size and fitted, and in the foreground sanded to final size and shape. At about this stage I like to stain all the round sections of the masts and spars; all those areas in fact that will not be finally painted black. I use a mixture of burnt sienna and raw umber artists’ oil colour, preferably of the quick-drying variety which is now available. I will mix this with a little satin finish polyurethane varnish and white spirit, and then after brushing it on the spar wipe it to a smooth finish with the tip of a finger.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig124.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig124"
    }
  }, [_vm._v("124.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("To make the jaws for the gaffs the ends of the spars are planed off on either side, and roughly shaped, oversize jaws glued in place. Then, first with a drill, and then using a fine burr or stone, the gape of the jaws is opened up to the diameter of the mast.")])])])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig125.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig125"
    }
  }, [_vm._v("125.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("They can then be finally shaped, again using a variety of stones and burrs.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig126.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig126"
    }
  }, [_vm._v("126.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The top for "), _c('em', [_vm._v("Neufchatel")]), _vm._v(" is built up, rather unusually, from open spaced battens, making it a little more difficult to make than a planked one. The first job is to prepare and glue strips of boxwood to a sheet of stiff card for the crosstrees, but only at their ends. The three strips of box at the front will form the crosstrees and, although the battens will be glued to all four, the rearmost one is simply for temporary support and will ultimately be cut away. The battens themselves were cut from some scraps of wood shaving mounted on paper left over from another job, which explains why some are black and others natural. Enough were cut and mounted on the crosstrees for the tops of both models.")])])])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig127.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig127"
    }
  }, [_vm._v("127.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Next, the wooden rim was carefully cut from a plane shaving and glued to the battens while these were still mounted on the card. When dry the whole ensemble can be removed, turned over and the unwanted battens around, and in the centre of, the top carefully cut away. Now the trestletrees are made, with slots cut or filed out to fit over the crosstrees. They are, of course, fitted from below, something not entirely clear in this photograph because I have subsequently fitted strips of shaving over the forward section of the trestletrees. At this stage it is important to check for fit over the masthead, and once this is done the bolsters can be added.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig128.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig128"
    }
  }, [_vm._v("128.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Initially, using the disc sander and then a sanding board, the ends of the cross- and trestletrees were tapered. Finally, a thin paper rim was fitted all around the edge of the top. Before painting and fitting to the mast, holes need to be drilled for the topmast shrouds and a slot cut for the foreyard sling.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig129.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig129"
    }
  }, [_vm._v("129.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Before fitting the tops, all the mastheads are carefully finished to their final dimensions and the edges chamfered to an octagonal section.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig130.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig130"
    }
  }, [_vm._v("130.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Now the tops can be glued in place and wire rigging, of the correct diameter for the lower and topmast shrouds, wound around the masthead to represent the upper ends of the shrouds.")])])])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig131.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig131"
    }
  }, [_vm._v("131.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("I always used to make mastcaps from boxwood for all my models, but recently, on small models, I have been constructing some of them "), _c('em', [_vm._v("in situ")]), _vm._v(" from card and paper. As I am building two models I can demonstrate both methods here, so first of all here is the card method. This is made feasible by the use of the ultra-thin superglues now available from model shops and suppliers. However, all the actual construction of the top is done using a thick and tacky superglue that will obviously set quickly and not soak into the card.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The first stage in the process is to glue a piece of card to the very top front edge of the lower masthead. In size this should be the depth of the cap and the width of the masthead. Now fit the topmast in its hole in the top and offer it up to the card; hold in place while checking against the plans to see if the angles of both masts are correct. If they are not then either trim the card back a little or add another layer of paper or card. When satisfied, glue the topmast in place, both to the top and the card. If you want to make a really strong fixing then drill through both masts and the card spacer with a size 80 or similar drill and fit a wire pin. The rest of the top can now be assembled as shown, using card of the correct thickness. When all four sides have been fitted the whole cap is liberally treated with the thin superglue, applied very carefully with a wire so that it does not get on to the areas of exposed mast. The card will soak up this glue like blotting paper, turning it into a very tough fibre-board that can be sanded and drilled with ease.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq22.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig132.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig132"
    }
  }, [_vm._v("132.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The finished caps, sanded to their final shape.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig133.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig133"
    }
  }, [_vm._v("133.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("A cap made from boxwood; the method should be largely self-explanatory. The cap should first of all be made over-large as shown on the right of the picture, before trimming to final size. Care is required to ensure that the round hole for the topmast and square one for the masthead are exactly the right distance apart.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig134.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig134"
    }
  }, [_vm._v("134.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("The bowsprit, jib-boom and flying jib-boom were all turned in exactly the same manner as the other spars, but bowsprit and jib-boom were left a little oversize at their inboard ends to allow for planing them to an octagonal section. The bowsprit was treated in the same way at its tip, though in his case to enable it to be planed square. A tenon was cut at an angle on the inboard end of the bowsprit to fit the gap between the fore bitts and sit flush with the deck. A recess was then cut to accept the bees which were made from 1/64in ply, and a saddle for the spritsail yard made from paper and wire.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("To assemble the bowsprit and jib-boom I used the same card technique to construct the cap as was used on the masts, with a small rectangle of card used for the jib-boom saddle where a second pin was fitted through both spars. The job was then completed by fitting a paper strap around both to represent what appears to be a metal strap on the plans, rather than a rope lashing. The flying jib-boom irons were formed by winding some fine wire around and between both spars in a figure-of-eight motion for three or four turns, bedding them tightly together and finally securing with a little superglue. They were subsequently further built up with woodworking adhesive and painted. One detail I accidentally omitted to fit at this stage was the traveller for the jib-stay. See photograph 169.")])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig135.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig135"
    }
  }, [_vm._v("135.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The masts and bowsprit assembled and painted. I chose to use an airbrush for this job mainly because of the fine slats of the foretop, but careful hand-painting would serve just as well.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig136.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig136"
    }
  }, [_vm._v("136.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Now the spars need to be brought to the same degree of finish. Both they and the booms and gaffs have been fitted with the necessary ironwork, and copper wire inserted in pre-drilled holes; these will be used to give a secure fixing to the mast. I have also inserted a wire pin in the centre of the fore yard for the same reason, but have not extended the same treatment to the upper yards as it would weaken such small items.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig137.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig137"
    }
  }, [_vm._v("137.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("A couple of other mast fittings can be made at this stage and then set aside till required. The first are the mast coats, and these I chose to turn. This can be done on a lathe or, as is demonstrated here, in the chuck of the little drill I keep fixed to my bench. A length of boxwood dowel is drilled to the diameter of the mast with successively larger bits in a Minicraft drill, both drills revolving. A little practice may be required to keep the drill centred and in line with the dowel, but it is actually easier than it looks.")])])])]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig138.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig138"
    }
  }, [_vm._v("138.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Now the coat can be sanded and parted off with either a sharp blade or a razor saw. It may help to insert the shank of the drill while doing this; it is a delicate operation and care is needed.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig139.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig139"
    }
  }, [_vm._v("139.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("Secondly, the mast hoops should be prepared in advance, and a mental note made not to fit any lower mast fittings like spider bands or goose neck for the boom until they have been threaded on to the mast. I speak from experience.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("I have seen these bands made very successfully from painted wire but I have always used the following method. Dowel of a slightly greater diameter than the mast is firstly prepared and lightly waxed. Then a strip of ordinary brown gumstrip is wound once around the dowel before moistening the remainder and making another couple of turns. When dry the surplus paper is trimmed away.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig140.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig140"
    }
  }, [_vm._v("140.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Then individual hoops are cut from the paper tube by placing the knife blade on top of it and carefully rolling the tube forward with the blade, taking great care to cut just a hoop’s width from the end. The individual hoops are now picked up with tweezers and dipped in some of the thin superglue on a piece of glass, then touched to some absorbent paper to remove any surplus and placed on some non-absorbent paper to dry. This method produces strong and realistic hoops: no other treatment is required. Now the yards and spars can be set aside while rigging material and blocks are prepared.")])])])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Block Making")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig141.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig141"
    }
  }, [_vm._v("141.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("At a larger scale I usually make the blocks from wood, but it is not a very viable method for a small vessel at this scale. I also make them from Milliput, an epoxy putty, that works reasonably well. A long thin sausage of Milliput is rolled out to the required diameter and is then allowed to partially set. It is then slightly flattened and individual blocks are sliced from it. They are stropped by gluing a length of wire to one side, which when dry is bent to a dog’s leg to line up with the centre of the block; a fine groove is then filed on either edge to suggest the sheave openings. One of the disadvantages of this method is catching the Milliput at just the right degree of set for rolling and cutting, which also, of course, means that there is quite a limited time for carrying out these tasks.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("On the "), _c('em', [_vm._v("Neufchatel")]), _vm._v(" models I made the blocks with punched ovals of card. I have in the past bought various sets of punches of varying degrees of uselessness, some of which were redeemable by returning on the lathe, but I have yet to find any quality punches small enough for this sort of work. Provided you have access to a lathe they are very easy to make. For many years I used punches made from 4- and 6in nails. The three on the right of the picture above are examples of these, and they did sterling service though they needed regular sharpening; finally I decided to make some from silver steel. The process is quite straightforward. A suitable length of steel rod is fitted in the lathe chuck and a drill of the required size in the tailstock. The rod is then drilled, turned, removed from the lathe and a section of the shaft ground away to allow access to the drilled hole a little way up the shaft. A blowtorch is then used to heat the tips to a bright cherry-red before plunging them into a tin of engine oil to temper them. If they are to be used for making blocks then at the cherry-red stage they are taken to the anvil (the top of a steel vice in my case) and the end of the punch is gently beaten on two sides until the required profile is achieved; they are then reheated and plunged. The tips are finally sharpened and polished on a leather wheel. The seven punches on the right have been shaped for block making.")])]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig142.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig142"
    }
  }, [_vm._v("142.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("I use the end grain of a block of boxwood while punching, with the paper or card being used held in place with a little Sellotape. Several ovals at a time can be punched before expelling with the little wire ejector.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig143.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig143"
    }
  }, [_vm._v("143.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("It would be quite impossible to demonstrate making one of the 7in blocks being punched in the previous photograph, so I am making a 24in block here (larger than any on "), _c('em', [_vm._v("Neufchatel")]), _vm._v("). A length of suitable wire rigging has been dipped in white glue and offered up to one of the ovals.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig144.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig144"
    }
  }, [_vm._v("144.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("When dry, more white glue is brushed on to the wire and it is turned over and placed over the second oval. If a double block is required a short strip of wire is added to one face and the process repeated. A little more glue can then be used to close the ends of the block. Finally, as with the mast hoops, each block is treated with thin superglue.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig145.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig145"
    }
  }, [_vm._v("145.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("When a batch of blocks is completed they are mounted in modelling clay on a strip of wood and painted black. I used an airbrush, but would hand-paint if there were only a few of them. Then both sides are painted brown, leaving a black centreline for the strop. It sounds rather fiddly painting blocks this way, but when you get into the swing of it two little brush strokes deal with each side and the job gets done surprisingly quickly. The large blocks in the foreground are 24in, those on the left 7in and those on the right 10in.")])])])]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Masting and Rigging")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig146.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig146"
    }
  }, [_vm._v("146.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("I have always used copper wire for rigging miniature models. I have experimented with other materials but have found them generally unsatisfactory. The majority of my stock is tinned copper bought many years ago from Ormiston Wire Ltd (See Materials and Tools, page 126). The finest has a diameter of 0.080mm, and the remaining seven spools are successively larger. The one non-tinned wire I use is from a spool of very thin ordinary copper wire that I use for the finest ropes.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig147.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig147"
    }
  }, [_vm._v("147.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("For 1½in and 2in ropes I use a single strand of the two finest wires, but for all other sizes two or three strands of wire need to be wound together. This is easily accomplished with either a lathe or mounted drill. The requisite number of strands are removed from the spool and given a slight stretch to straighten them, and the ends then inserted in the chuck, doubled over a couple of times, and given a few twists; this gives the chuck something to bite on. Now hold the other ends taut and run the drill until the rope is satisfactorily formed, then give it another slight stretch before removing it from the drill. I show only a short length of rope being wound here; I would normally make lengths of at least 3ft, being limited only by the spread of my hands from the end of the wire to the switch on the drill.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig148.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig148"
    }
  }, [_vm._v("148.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("I paint the rigging with matt Humbrol enamels, No 29 (dark earth) for the running rigging and a very dark brown of my own mixing for the standing rigging. It is applied in the following way. A long piece of hardboard, used specifically for the purpose, is placed on the bench and a brush full of paint puddled on it about a foot from the edge. A length of rigging is laid along the board and steadily drawn through the puddle and under the brush, allowing the wire to drag across the surface of the board a short distance to remove any surplus paint. It then needs to be hung up to dry. I find double-sided tape along the edge of a convenient shelf to be the answer to this.")])])])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig149.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig149"
    }
  }, [_vm._v("149.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("When the rigging is painted it needs to be stored. I have a set of homemade drawers, two of which are used for this purpose. One of them has a strip of plasticine at either end into which lengths of rigging are embedded, and the other has a series of channels and is primarily used for shorter lengths, offcuts and less frequently used sizes. The channels were made by scoring a sheet of card and then folding it concertina fashion to form the individual dividers, and then applying a little glue where necessary.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig150.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig150"
    }
  }, [_vm._v("150.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Another solution (I use it as backup, particularly when rigging a larger vessel) is to make use of the inside of a cupboard door. Two battens of wood are fitted top and bottom and double-sided tape applied to them.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig151.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig151"
    }
  }, [_vm._v("151.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("With masts and spars made and blocks and rigging material prepared I have now returned to the job of detailing the masts. To keep things clearer I shall be showing the assembling of the bare-spars model, followed by notes and photographs showing preparation and fitting of sails as used on the waterline model.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("All the shrouds fitted with ratlines on my miniature models are prepared in the same way. However, those for the topmasts, and on some models the topgallant masts, are prepared and fitted before the masts are finally glued in place on the model. The lower shrouds are prepared at a later stage, the reasons for which will become clear in due course.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The method I use for making these is as follows. First I use a little machine vice to secure the mast in an upright position, and then cut out a triangle of card that will sit squarely along the edge of the maintop and between the topmast crosstrees. I now mark the base of the card where the holes have been drilled for the shrouds and the top of the card in line with the topmast head. The card is then removed and the shrouds drawn in as shown in this photograph.")])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig152.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig152"
    }
  }, [_vm._v("152.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The card has been removed and laid on top of another piece of card, carefully lining up the bases of both pieces of card. A knife or scalpel is then used to mark through both pieces at either end of the shrouds, so marking exactly the layout on the card beneath. This is then turned over and the knife cuts joined up to give a mirror image of the original. We now have a plan for both port and starboard topmast shrouds.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig153.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig153"
    }
  }, [_vm._v("153.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("I have quite a collection of jigs that I use for the preparation of shroud assemblies. These two will fit the bill admirably for "), _c('em', [_vm._v("Neufchatel")]), _vm._v(", they can be made from any stable board about ¼in-½in thick, they are fitted with a strip of wood top and bottom, wide enough to give a raised edge of about ⅛in on either side. Strips of paper marked at 15in scale divisions are then glued to either edge and on both sides of the jig; 2mm is about right for this scale. I mark out a fairly large area using a ruler and set square and then trim strips off when required.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig154.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig154"
    }
  }, [_vm._v("154.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The two shroud plans are now glued either side of the jig, immediately opposite one another. Note the black guide lines on the jig, it is important that the base of the card plan is parallel with one of these; this will ensure that the ratlines run parallel with the maintop and the waterline. Obviously this is not always true for lower shrouds, as channels are not always horizontal and ratlines should be. This difference then has to be allowed for.")])])])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig155.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig155"
    }
  }, [_vm._v("155.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Before starting to wind the shrouds the four edges of the jig have strips of double-sided tape attached to them, and the backing tape at top and bottom removed. Now a length of 4in wire is wound and a knot tied in one end. This is inserted in a slot cut with a razor saw in the base of the jig and pulled tight.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig156.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig156"
    }
  }, [_vm._v("156.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The winding of shrouds and ratlines is quite straightforward; the shrouds go on first, lining them up with the plans on each side of the jig. The backing is then removed from the tape along the sides and the ratlines are wound over the top of them, lining them up with the marks on the paper strips. When completed, superglue is run along each shroud, applied with a fine wire.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig157.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig157"
    }
  }, [_vm._v("157.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Now the ratlines can be cut through either side of the shrouds, and a downwards sag carefully put on each between the shrouds. Next, discs of paper are punched to represent the deadeyes and glued in place. The upper one should be set slightly off-centre to allow for the later fitting of the turned-in end of the shroud. Finally, two of the lengths of lanyard are glued in place, the centre and right-hand ones on each deadeye.")])])])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig158.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig158"
    }
  }, [_vm._v("158.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("I have cut back the tip of a No 11a scalpel blade to allow me to reach between shroud and lanyard and cut away the section of shroud between the deadeyes.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig159.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig159"
    }
  }, [_vm._v("159.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The shrouds are then turned over and short lengths of wire glued in place to represent their turned-in ends, and the ratlines trimmed right back to the outside shrouds. The work is then completed by building up the deadeyes flush with the shrouds using white glue and then fitting the remaining lanyard lengths. Finally, all but the lanyards are given a coat of dark brown paint. I did this with several thin coats applied with a brush as it hardly seemed worth setting up the airbrush for two such simple assemblies.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig160.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig160"
    }
  }, [_vm._v("160.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Bobstays and bowsprit shrouds are next made up, but not being formed on a jig each one can be constructed in two parts, obviating the removal of the section between the deadeyes. Also each deadeye was formed from two paper discs, one either side of the wires.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig161.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig161"
    }
  }, [_vm._v("161.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("Before fitting the spider bands the mast hoops must be threaded on to the mast.")]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("This photograph shows the paper spider band fitted to the mast. It has been drilled to take the lugs for the belaying pins. In the foreground a length of wire is being twisted round a belaying pin, it can then be trimmed and glued into one of the holes. Just above it can be seen the mast band carrying the saddle for the boom gooseneck. I made the saddle from a piece of very fine tubing produced by stretching an empty refill from a ballpoint pen after softening it in a candle flame. This was bound to the mast with some fine wire to produce the mast band and a strong anchorage for the saddle. The wire was treated with a couple of coats of superglue to disguise the individual strands and painted. I really do not know why I am telling you this because when it came to fitting the boom I decided to straighten the gooseneck and drill a hole in the mast immediately above the band. It made a more secure fixing and was visually virtually identical. However, if at some time in the future you are in need of some very fine tubing, spacers or washers, try a ballpoint refill.")])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig162.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig162"
    }
  }, [_vm._v("162.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("The lower end of the masts completed. A dummy bolt has been fitted from the base of the boom saddle, and the mast coats glued in place while "), _c('em', [_vm._v("in situ")]), _vm._v(" on the model to ensure a tight fit to the deck.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig163.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig163"
    }
  }, [_vm._v("163.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("Now the following fittings can be added to the masts and bowsprit. Working down from the top of the foremast are blocks for the flying jib halyard, main topgallant braces, topsail yard lifts, outer jib halyard, fore yard lifts, main topmast stay, gaff peak and throat halyards, the fore topsail halyard, pendants of tackles and the blocks under the fore top for the spritsail yard braces and fore yard buntlines. The topsail reef tackles can also be made up and fitted along with the trusses and sling for the fore yard. Finally, the fore topmast shrouds are glued in place.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("On the mainmast, again working downwards, blocks are fitted for the fore topgallant brace, fore topsail yard brace, gaff peak halyard, boom topping lift, pendants of tackle and gaff throat halyard.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("On the bowsprit assembly, working inboard from the tip of the jib-boom, footropes are fitted back to the bowsprit cap. The jib stay outhaul is fitted under the jib-boom, and blocks are in place for the topgallant, topsail and foresail bowlines.")])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig164.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig164"
    }
  }, [_vm._v("164.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("There are three other fittings that can be added to the model before embarking on the final rigging. I purposely left them till this late stage as they would be easily damaged if accidentally snagged while working on the hull. They are the anchors, boomkins, and tackles for the mainstays. The fitting of anchors and boomkins should need no further explanation than that given in the photograph; however, a little more information about the mainstay tackles is necessary. These ropes would be long enough to allow one of them to be slackened off sufficiently for the fore gaff sail to be swung out to port or starboard. This feature can be seen quite clearly in the photographs of the finished waterline model.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig165.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig165"
    }
  }, [_vm._v("165.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The boom and both gaffs have been fitted to the masts. This should initially be done while in place on the model to ensure they are set at the correct angle. They can then be fitted in a vice or block of wood and the peak and throat halyards and boom topping lifts fitted.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig166.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig166"
    }
  }, [_vm._v("166.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Also fitted at this stage were the gaff parrel beads made from some of the tiny glass beads used for the shot.")])])])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq23.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig167.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig167"
    }
  }, [_vm._v("167.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Now the bowsprit is finally glued in place and will be rigged before fitting the masts. The first item to be added is the lower end of the forestay. The wire was first of all bent round a drill shank and bound in place with a fine wire whipping. The deadeyes were then formed by gluing two punched discs of paper either side of the circle of wire. Plenty of superglue was used to allow it to fill the intervening space.")])])])]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig168.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig168"
    }
  }, [_vm._v("168.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("After the forestay collar the gammoning, bowsprit shrouds and bobstays are added. Then comes the dolphin striker (pre-drilled with four holes), through which are threaded the jib-boom and flying jib-boom martingale stays and the fore royal and fore topgallant stays, all set up with single blocks to the bulwarks either side of the bowsprit. Next, from their respective blocks to the fore pin rail, via holes drilled in the fairleads at the bow, bowlines are fitted for the fore course, topsail and topgallant, as well as the spritsail lifts and the jib outhaul.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("When fitting the stays to the end of the spars I bind them in place with the finest of wire taken once round the spar and shroud and tied with a half hitch. The shroud can then be pulled taut and a spot of glue applied, the end of the shroud trimmed, and a couple more turns of the wire given before finishing off.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig169.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig169"
    }
  }, [_vm._v("169.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("One detail I have now to fit is the traveller for the jibstay; this was fiddly work because I had to work around all the rigging that was now in place. It consists of a wire hoop with another smaller loop at the top to which the stay will be attached and the short length of outhaul from sheave to traveller. If you refer back to photographs 132 and 133 you will see how much easier it would have been to make and then fit the traveller at that stage.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig170.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig170"
    }
  }, [_vm._v("170.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("As the work of rigging the model proceeds I add to the protective structure around it. Here I have fixed a bracket at either end to protect the flying jib-boom and boom, once it has been added, and have made a couple of wooden and card brackets to protect the spritsail yard.")])])])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig171.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig171"
    }
  }, [_vm._v("171.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The jib-boom and flying jib-boom guys are next made up with their tackles and fitted, first inserting the ends in holes drilled in the catheads, then gluing them to the spritsail yard before taking them to the ends of their respective booms.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig172.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig172"
    }
  }, [_vm._v("172.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("Now the masts can be permanently glued in place, taking care that they are accurately positioned by checking from above and from bow and stern. When they are satisfactory the fore-and-aft stays are added, all except for the fore royal and main topgallant stays, These will be among the final items of rigging to be fitted due to their vulnerability, particularly when fitting the upper yard parrels.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The lower stays are installed as shown in the photograph, roughly shaped like the wire held in the foreground before feeding it around the masthead and drawing the two strands together with a whipping of fine wire. The remaining wire end is then cut away and white glue used to build a mouse around the whipping.")])]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig173.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig173"
    }
  }, [_vm._v("173.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The fore-and-aft stays in place along with the running rigging from all the blocks previously fitted to the masts down to the various pin rails.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig174.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig174"
    }
  }, [_vm._v("174.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("A close-up of the ropes brought down to the spider band and fore pin rails.")])])])]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig175.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig175"
    }
  }, [_vm._v("175.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The main spider band and rails.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig176.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig176"
    }
  }, [_vm._v("176.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The stern, depicting the lashing I have fitted round the gaff, the boom sheets and the guy pendants.")])])])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig177.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig177"
    }
  }, [_vm._v("177.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The lower shrouds are next prepared using exactly the same method as was used for the topmast shrouds, see photographs 149–157.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig178.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig178"
    }
  }, [_vm._v("178.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("When the shrouds had been completed and trimmed to fit between masthead and channels, I put a whipping of fine wire around all three shrouds as near the top as possible and then threaded a length of wire around the middle shroud, bringing both ends up in front of the whipping and gluing it in place with a spot of superglue.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig179.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig179"
    }
  }, [_vm._v("179.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Notches are now cut in the edge of the channels and the shrouds glued in place, taking care that the upper ends of the shrouds are exactly lined up with the masthead.")])])])]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig180.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig180"
    }
  }, [_vm._v("180.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The two lengths of wire attached to the top of the shrouds are now taken across the top, beneath the stay collars and are tied together in a half hitch before being drawn firmly but very gently tight. All can now be glued before trimming off the loose ends, and more superglue applied around the very top of the shrouds.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig181.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig181"
    }
  }, [_vm._v("181.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The foremast futtock shrouds and lanyards are the next item to be fitted, followed by the ropes from the blocks under the top down to the pin rails. When fitting ropes such as these I cut them exactly to length before gluing them to the block. The lower end is then manoeuvred into its place on the pin rail. I usually find that this is most easily accomplished working from the opposite side of the ship with a thin boxwood push-stick with a flattened end and with a V cut in it. Then you have to reach through to apply a spot of superglue with a length of wire. It is fiddly work that becomes more difficult as the model progresses, and anyone who can complete the rigging of a model of this type without doing at least some damage to previously fitted rigging is a better man than I.")])])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("Before moving on with the assembly, the following items of rigging need to be prepared: the fore and main topmast and topgallant backstays, the fore royal backstays, the fore and main topsail halyards and the section of boom topping lift with its tackle from the blocks at the masthead down to the channels. The backstays are made up as previously described and the halyards in similar fashion by gluing all the ropes to one side of the blocks before fitting the other. The blocks can then be painted as shown earlier in photgraph 143.")])]), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig182.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig182"
    }
  }, [_vm._v("182.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("When completed and painted the stays and halyards can be fitted. This photograph of the main masthead shows the remaining section of the boom topping lifts glued to their blocks and also shows how the wires used to draw in the shrouds close in to the top have blended in beneath the mainstay collar.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("I find the best way to secure the backstays in place is to first glue the lower ends in their notches in the channels or the holes drilled in the rails (depending which stays are being fitted) and then loosely tie opposing backstays and the relevant masthead together with a loop of fine wire, again using a half hitch. Keeping the stays taut, the half hitch is pulled tight and a spot of glue applied. When the glue has set all the loose ends are removed.")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig183.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig183"
    }
  }, [_vm._v("183.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Capping rails and chain plates cut from black paper and then treated with superglue. The bolts for the chain plates are formed from dots of white glue applied with the tip of a fine brush.")])])])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig184.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig184"
    }
  }, [_vm._v("184.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("With the masts in place and partially rigged it is now time to return to the yards. This photograph shows the ends of the fore yard being drilled to receive the boom irons; a job that is best got out the way while it is easy to grip the yard firmly without causing damage to the delicate fittings soon to be added to it.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig185.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig185"
    }
  }, [_vm._v("185.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("A very fine twist drill could be used to drill the yardarm ends, but a home-made drill with more rigidity and a sharp point makes the job much easier. The drill bit being used in the previous photograph and in many others throughout the book was made in the following way. An old drill bit was mounted in a Minicraft tool and offered up to a small grind wheel as shown, with both in motion. When the desired length and diameter of the tip is achieved the drill is stopped and the tip lightly touched to the wheel, at an angle, on three sides to provide a sharp three-sided cutting tip.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig186.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig186"
    }
  }, [_vm._v("186.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Before fitting the boom irons, strops of wire rigging are glued in place around the yard for the various blocks and tackles to be fitted, and then holes drilled to receive them, alongside or between the strops. Here lift, brace and leech-line blocks can be seen glued in place. Wire for the shanks of the irons can now be glued in the holes in the ends of the yards and bent to a right angle. The same drill is used to drill through the stunsail booms; these are now fitted and glued, a lashing put round the inboard end of the spar and the surplus wire trimmed off.")])])])]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig187.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig187"
    }
  }, [_vm._v("187.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The boom irons are completed with the addition of paper hoops. A second iron will be needed a third of the boom’s length from the end.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig188.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig188"
    }
  }, [_vm._v("188.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The yards with most of their fittings; they are now ready for adding to the model. From the top they are the fore topgallant, main topmast, fore topmast and fore yard. Beneath them are the two lower stunsail booms. As these yards are for the model with bare spars, the fore royal yard and main topgallant yard are omitted; they would only have been crossed when in use and would have been set flying (without either braces or lifts).")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig189.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig189"
    }
  }, [_vm._v("189.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("The first of these spars to be fitted are the lower stunsail booms. Two holes are drilled in the channels and a wire bracket fitted; they can then be glued and lashed in place.")])]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig190.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig190"
    }
  }, [_vm._v("190.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("Before finally fixing it to the model, the fore yard was fitted with strops for the trusses and sling; the footropes were also added along with the yard arm tackles. These and their coiled falls have been made up beneath the yard. The yard was then fitted to the model by the wire pin (see photograph 134) and the parrel fitted by threading the rope twice round the mast and once round the yard either side of the sling. This is fiddly and frequently frustrating work and patience is required. I always think that the time spent on some of these quite insignificant items is out of all proportion to the final result. Next, the lifts, buntlines and leech-lines are taken from the blocks on the yard to their respective blocks on the mast or under the tops, and the clue lines and sheets taken down to deck. The three components of each bowline were threaded under the stunsail boom and tacked in place before taking the top end around the yard to meet itself on the fore side. These and other items of running rigging to the sails are tied off at convenient points on a spar or at a block, and may be omitted completely on a model such as this one.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("This is also a good time to rig the spritsail yard braces, from the forestay collar to the blocks on the yard and back to the blocks under the top.")])]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig191.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig191"
    }
  }, [_vm._v("191.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("Several feet beneath the fore yard can be seen the blocks for the cluelines, sheets and tacks. Before fitting these to the yard, or rather slinging them beneath it, they were made up as shown and the cluelines used to attach them to the yard. Then the sheets and tacks can be rigged to their sheaves or blocks.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig192.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig192"
    }
  }, [_vm._v("192.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The fore topsail yard with the lifts, halyard and bowlines in place. Notice also in the bottom right-hand corner the cluelines whipped to the sheets in the absence of a sail.")])])])]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq24.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig193.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig193"
    }
  }, [_vm._v("193.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The fore topgallant yard with parrel, halyard, lifts and bowlines rigged. The cluelines have been fitted in the same manner as those for the topsail. The two ropes pointing to the top left-hand corner of the picture are the topgallant shrouds in the process of being fitted, they have been glued to shrouds and crosstrees and will now be angled in towards the mast, trimmed and glued in place.")])])])]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig194.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig194"
    }
  }, [_vm._v("194.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("The main topmast yard rigged following the same sequence as the fore yards.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("With the bulk of the rigging completed the vulnerable fore royal and main topgallant stays can be fitted and a Stars and Stripes (painted with acrylics on tissue paper) fitted to the mainmast…")]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig195.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig195"
    }
  }, [_vm._v("195.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("… and a pennant to the fore. All that now needs doing is to fit the remaining braces to the yards and the rigging is completed. I have not shown this last procedure in detail as it is very straightforward and clearly shown on the plans and in the final photographs.")])])])]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_c('h5', {
    staticStyle: {
      "page-break-before": "always!important"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  }), _c('em', [_vm._v("Making and Rigging Sails")]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig196.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig196"
    }
  }, [_vm._v("196.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("For those wanting to depict a waterline model under sail there are still the sails to be made and set on the masts and spars. The first job is to prepare ample sailcloth for the model with enough to spare for a few accidents. I use some quite fine tissue paper for this and tape it out over a completely flat surface like a sheet of glass. Then, using double-sided tape, a long steel rule is fixed to the glass at the bottom of the sheet. A ruler marked in millimeters is laid against the steel one and a set square used to mark in the individual cloths with a very sharp 4H pencil. On a full-scale ship these would normally be 24in wide, so I mark them 3mm apart, which, allowing for the overlap at the seams, would seem to be about right. Then the whole process is repeated on the other side of the paper, taking great care that the pencil lines are exactly in line with the original ones. The sheet of tissue is next taped over a wooden frame so both sides are exposed and is airbrushed on both sides with a very dilute mix of acrylic paint, matt medium and water. The finish I try to achieve is a slightly creamy off-white. This treatment will not only colour the tissue but will greatly strengthen it.")])])])]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig197.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig197"
    }
  }, [_vm._v("197.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The sails are cut from the tissue using the plans for reference, but a little oversize as can be seen here. They can then be offered up to the relevant masts and spars and checked for fit before final trimming to size.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig198.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig198"
    }
  }, [_vm._v("198.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("Each sail is now shaped over a rounded surface, a technique expounded by the late Derek Hunniset, and I have used it for many years now. Here I am using part of an old plastic basin, but any smooth surface with the right curvature will suffice.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("In practice water is applied to both sides of the sail and it is gently stretched to shape, smoothing out any wrinkles as you go. Splits are frequent, then you start again, hence the need to prepare extra sailcloth.")])]), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig199.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig199"
    }
  }, [_vm._v("199.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("When a satisfactory result has been achieved, the sail is covered with a cloth which is pulled tight, twisted and gripped with one hand while the other applies heat with a hair dryer. Experimentation will determine the length of time that it takes to dry the sail before starting to wrinkle it.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq25.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig200.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig200"
    }
  }, [_vm._v("200.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The sail can then be lifted free and checked for blemishes. If it is all intact it can be returned to the mould for detailing. This involves fitting all the linings and reef bands. If the leech linings are left over long they can be glued to both sail and mould to keep the sail in place while detailing it (I use white glue) and then be trimmed free when the job is completed. The sail is then turned over and the tablings, bolt ropes and cringles added.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq26.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig201.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig201"
    }
  }, [_vm._v("201.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The sail can then be glued to the yard. I have held them both in place here; it makes the whole job much easier. At this stage the spar should be detailed as described earlier and any reef points that are required fitted.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-Seq27.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig202.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig202"
    }
  }, [_vm._v("202.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "l-caption"
  }, [_vm._v("The spanker not only needs to be glued to the gaff but has to be glued to each of the wooden hoops around the mast. As each one is glued to the sail the edge of the sail should be given a little curve in the direction of the wind before gluing to the next one. On my model the foot of the sail has been trimmed by hoisting the tack. I have come across this feature many times in copies of contemporary engravings, so it must have been quite commonplace. Whether it was to improve visibility, allow the wind to fill another sail or just a way of reducing sail I do not know, but it makes an attractive feature and also gives a clearer view of the deck with its fittings. The shaping is achieved by dampening the sail whilst concertinaing and teasing it to the desired shape. The curves are relatively easy to form, and should hold their shape well with the stiffening effect of the wire bolt ropes.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "images/ch2-fig203.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "l-caption",
    attrs: {
      "id": "ch2-fig203"
    }
  }, [_vm._v("203.")]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("The jibs are all fitted to their respective stays by means of rope hanks. These short lengths of wire are initially glued to one side of the sail, which is then turned over, the stay laid over them, and the hanks bent round the stay to the other side of the sail, where, if need be, they are trimmed before a touch of superglue fixes them in place. I have shown the flying jib in the process of being hoisted. Instead of being mounted to the stay by the hanks I have formed them round a rather more rigid length of wire which was then glued to the chipboard frame while shaping the sail. When I was satisfied with the result the wire was withdrawn from the hanks and the stay inserted.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1",
    staticStyle: {
      "margin-bottom": "1em!important"
    }
  }, [_vm._v("Although shaping a sail in this way has its difficulties, it gives, in my opinion, more life to a model, a greater feeling of realism and atmosphere, and besides, it is very satisfying and great fun to do, which is, of course, what it is all about.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "1em!important"
    }
  }, [_vm._v("This just about concludes my task of describing the construction of these two models. Anything that I have failed to make clear should be readily made so by referring to the plans or one of the volumes in the bibliography.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The photographs of the completed models of "), _c('em', [_vm._v("Neufchatel")]), _vm._v(" should also help in this direction. I know")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("that in my early days as a modelmaker, good photographs of models were one of my greatest research assets, helping me to understand and interpret complicated and confusing plans.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The waterline model of "), _c('em', [_vm._v("Neufchatel")]), _vm._v(" is displayed in a glass case finished with Lacewood veneer, and the full-hull model in one finished with Myrtle Burr veneer.")])])]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ce29f8b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/09_chapter2.vue
// module id = 81
// module chunks = 0